import { useMemo } from "react";
import { useFeira } from '../../Contexts/FeiraContext';
import MapaDesktop from './MapaDesktop/index';
import MapaMobile from './MapaMobile/index';
import Loader from "../../Components/Common/Loader";

const MapaLoader = () => {
  const { isMobile, loading } = useFeira();
  
  const view = useMemo(() => {
    if (loading) return <Loader />;
    return isMobile ? <MapaMobile /> : <MapaDesktop />;
  }, [isMobile, loading]);
  return view;
};

export default MapaLoader;